import { render, staticRenderFns } from "./ProductGalleryMobile.vue?vue&type=template&id=ca74b938&scoped=true&"
import script from "./ProductGalleryMobile.vue?vue&type=script&lang=ts&"
export * from "./ProductGalleryMobile.vue?vue&type=script&lang=ts&"
import style0 from "./ProductGalleryMobile.vue?vue&type=style&index=0&id=ca74b938&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca74b938",
  null
  
)

export default component.exports